import { ref, onMounted } from 'vue';
import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_URL;

export function useDonors() {
  const donors = ref([]);
  const donorsPremium = ref([]);

  const getDonorInfo = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/donor/search/all`);
      donors.value = response.data;
    } catch (error) {
      console.error('Error fetching donors:', error);
    }
  };

  const searchDonors = async (searchTerm) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/donor/search/${searchTerm}`);
      donors.value = response.data;
    } catch (error) {
      console.error('Error searching donors:', error);
    }
  };

  const getDonorPremiumInfo = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/dornorPremium`);
      donorsPremium.value = response.data;
    } catch (error) {
      console.error('Error fetching premium donors:', error);
    }
  };

  onMounted(async () => {
    await getDonorInfo();
    await getDonorPremiumInfo();
  });

  return {
    donors,
    donorsPremium,
    getDonorInfo,
    searchDonors,
  };
}
